import { render, staticRenderFns } from "./CoachMetrics.vue?vue&type=template&id=6dca2390&scoped=true&"
import script from "./CoachMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./CoachMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CoachMetrics.vue?vue&type=style&index=0&id=6dca2390&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dca2390",
  null
  
)

export default component.exports